module.exports = __webpack_public_path__ + "img/startpoint.d9718f19.svg";